import { useQuasar } from 'quasar'
import { provide, computed, reactive, watch } from 'vue'
import isEqual from 'lodash.isequal'
import { ConfirmationDialogExitConfirmation as confirmExit } from 'src/utils/dialogs'
import { useRoute } from 'vue-router'

/**
 * @param {string} dialogName
 * @param {Record<string, function>} emits
 */
export const useRouteDialogEmits = (dialogName, emits) => {
  for (const [key, value] of Object.entries(emits)) {
    provide(`${dialogName} - ${key}`, value)
  }
}

/**
 *
 * @param {object} emits
 * @param {function} emits.onDialogHide
 * @param {function} emits.onOKClick
 * @param {function} emits.onCancelClick
 * @param {function} [onClose]
 * @returns
 */
export const useDialog = ({ onDialogHide, onOKClick, onCancelClick }, onClose) => {
  const $q = useQuasar()
  const $route = useRoute()

  watch(() => $route.path, (val, oldVal) => {
    if (val !== oldVal) onCancelClick()
  })

  const dialogProps = reactive({
    position: computed(() => $q.screen.gt.xs ? 'standard' : 'bottom'),
    noEscDismiss: !!onClose,
    noBackdropDismiss: !!onClose,
    noRouteDismiss: true
  })

  const onCloseDialog = typeof onClose === 'function'
    ? () => onClose({ confirmExit, isEqual })
    : onCancelClick

  const dialogListeners = {
    hide: onDialogHide,
    shake: onCloseDialog
  }

  return {
    dialogProps,
    dialogListeners,
    onCloseDialog
  }
}
